<template lang="pug">
#laudos
    p {{ $t('laudos.selecioneTipoDeInsumoParaCriacaoDeLaudo') }}
    slot
        .modal-container-inner-filtros
        .filtro-tipo-consulta
            el-radio-group.radio-group-container(
                v-model='tipoBusca',
                @change='onChangeHandle'
            )
                el-radio.radio-button(label='CAR') CAR
                el-radio.radio-button(
                    label='TERRITORIO',
                    :disabled='desabilitarTerritorio(usuarioLogado)'
                ) {{ $t('laudos.territorio') }}
                el-radio.radio-button(label='ARQUIVO_VETORIAL') {{ $t('laudos.arquivoVetorialKml') }}
            #idTerritorio.busca.none
                SelecionarTerritorio(
                    :tipoLaudo='tipoLaudo',
                    @getTerritoriosSelecionados='solicitarLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio',
                    ref='selecionarTerritorio'
                )
            #idCar.busca
                SelecionarCar(
                    :tipoLaudo='tipoLaudo',
                    @getLaudos='getLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio'
                )
            #idVetor.busca.none
                SelecionarArquivoVetorial(
                    @update:lista='requestLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio',
                    :tipoLaudo='tipoLaudo'
                )
</template>

<script>
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio.vue';
import SelecionarCar from '@/modules/laudos/components/SelecionarCar.vue';
import SelecionarArquivoVetorial from '@/modules/laudos/components/SelecionarArquivoVetorial.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import LaudoService from '@/modules/laudos/services/LaudosService';
import { mapGetters } from 'vuex';

export default {
    name: 'Laudos',
    components: {
        SelecionarTerritorio,
        SelecionarCar,
        SelecionarArquivoVetorial
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.PARCERIA_SUSTENTAVEL_RASTREABILIDADE,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                car: '',
                tipoLaudoId: TipoLaudo.PARCERIA_SUSTENTAVEL_RASTREABILIDADE
            },
            totalLaudos: 0,
            laudos: [],
            idLaudo: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false,
            tipoBusca: 'CAR'
        };
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
        },

        solicitarLaudos(territoriosSelecionados) {
            this.changeShowModalSelecionarTerritorio();
            this.changeShowModalConfirmarTerritorios();
            this.territoriosSelecionados = territoriosSelecionados;
            this.$emit(
                'atualizarTerritoriosSelecionados',
                this.territoriosSelecionados
            );
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.getLaudos();
        },
        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },
        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },
        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },
        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },

        changeShowModalSelecionarTerritorio() {
            this.tipoBusca = 'CAR';
            this.$emit('showModalSelecionarTerritorios');
        },

        onChangeHandle() {
            this.showBusca();
        },

        showBusca() {
            if (this.tipoBusca === 'CAR') {
                $('#idTerritorio').addClass('none');
                $('#idVetor').addClass('none');
                $('#idCar').removeClass('none');
            } else if (this.tipoBusca === 'TERRITORIO') {
                $('#idCar').addClass('none');
                $('#idVetor').addClass('none');
                $('#idTerritorio').removeClass('none');
            } else {
                $('#idCar').addClass('none');
                $('#idTerritorio').addClass('none');
                $('#idVetor').removeClass('none');
            }
        },

        desabilitarTerritorio(usuarioLogado) {
            if (usuarioLogado && usuarioLogado.authorities.length > 1) {
                return false;
            } else {
                if (
                    usuarioLogado.authorities[0].authority ===
                    'ROLE_FEATURE_LAUDO'
                ) {
                    return true;
                }
                return false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .radio-group-container {
        max-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .radio-button {
        margin-right: 20px !important;
    }

    .none {
        display: none !important;
    }
}
</style>
